module.exports = __webpack_public_path__ + "img/likeIcon_white.d32fd827.svg";